import { theme } from '~components/web-components'

export const breakpoints = {
  values: theme.values,
}
